import type { BookingStatus } from '@/lib/types';

const STYLES: Record<BookingStatus, string> = {
  new: 'bg-gold/15 text-gold-deep',
  confirmed: 'bg-emerald-100 text-emerald-700',
  completed: 'bg-espresso/10 text-espresso',
  cancelled: 'bg-blush-soft text-blush-deep',
};

export function statusBadge(status: BookingStatus) {
  return (
    <span className={`inline-block rounded-none px-2.5 py-1 font-body text-[10px] font-bold uppercase tracking-wide ${STYLES[status]}`}>
      {status}
    </span>
  );
}
